module.exports = __webpack_public_path__ + "static/media/connection.0f68092d.svg";